// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"a29df89c","641":"ba3d4072","993":"eb99cf7f"}[chunkId] + ".chunk.js";
};